import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

let root: ReturnType<typeof createRoot> | null = null;

// Function to initialize the app
function initBlueEmuQuiz(elementId: string = 'root') {
  const container = document.getElementById(elementId);
  
  if (!container) {
    console.warn(`Element with id "${elementId}" not found. Blue-Emu Quiz could not be initialized.`);
    return;
  }

  // Clear existing content
  container.innerHTML = '';

  try {
    // Reuse existing root if available
    if (!root) {
      root = createRoot(container);
    }
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize Blue-Emu Quiz:', error);
  }
}

// Make the init function available globally
declare global {
  interface Window {
    initBlueEmuQuiz?: typeof initBlueEmuQuiz;
  }
}

window.initBlueEmuQuiz = initBlueEmuQuiz;

// Auto-initialize only in development and if we're not in an iframe
if (
  process.env.NODE_ENV === 'development' && 
  window.self === window.top
) {
  initBlueEmuQuiz();
}
